"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useFullscreen = function () {
    var _a = (0, react_1.useState)(document.fullscreenElement === document.documentElement), fullscreen = _a[0], setFullscreen = _a[1];
    var requestFullscreen = (0, react_1.useCallback)(function () {
        document.documentElement.requestFullscreen();
    }, []);
    var exitFullscreen = (0, react_1.useCallback)(function () {
        document.exitFullscreen();
    }, []);
    var toggleFullscreen = (0, react_1.useCallback)(function () {
        if (fullscreen) {
            exitFullscreen();
        }
        else {
            requestFullscreen();
        }
    }, [fullscreen]);
    (0, react_1.useEffect)(function () {
        var onFullscreenChange = function () {
            setFullscreen(document.fullscreenElement === document.documentElement);
        };
        document.addEventListener('fullscreenchange', onFullscreenChange);
        return function () {
            document.removeEventListener('fullscreenchange', onFullscreenChange);
        };
    }, []);
    return [fullscreen, requestFullscreen, exitFullscreen, toggleFullscreen];
};
exports.default = useFullscreen;
